import React, { useContext } from "react"

import classNames from "classnames"

import { useMergedRefs } from "shared/lib/useMergedRefs"

import { TabBarScrollContext } from "./TabBarScrollGroup"

export interface TabBarScrollContentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const TabBarScrollContentComponent = React.memo(
  React.forwardRef<HTMLDivElement, TabBarScrollContentProps>(
    ({ children, className, ...rest }, ref) => {
      const { contentRef, scrollRef, canScrollLeft, canScrollRight } =
        useContext(TabBarScrollContext)

      const mergedRefs = useMergedRefs(ref, scrollRef)
      return (
        <div
          ref={mergedRefs}
          {...rest}
          className={classNames(
            "tab-bar__scroll-container",
            {
              "tab-bar__scroll-container--shadow-left": canScrollLeft,
              "tab-bar__scroll-container--shadow-right": canScrollRight
            },
            className
          )}
        >
          <div ref={contentRef} className="tab-bar__scroll-content">
            {children}
          </div>
        </div>
      )
    }
  )
)

TabBarScrollContentComponent.displayName = "TabBar.ScrollContent"

export const TabBarScrollContent = TabBarScrollContentComponent
